module.exports = __webpack_public_path__ + "img/log2.2ad9dc66.png";